import { ApiReportReportTypeChoices } from "@api/graphql/types-and-hooks";
import { ReportNode } from "@providers/ReportProvider/context";

// Mirrors REPORT_TYPE_LABELS and _client_initials in frontera's report_review_notification_service.py, so the
// dialog names the report the way the review emails do.
const REPORT_TYPE_LABELS: Partial<Record<string, string>> = {
  [ApiReportReportTypeChoices.DiagnosisEvaluation]: "evaluation",
  [ApiReportReportTypeChoices.InitialAssessment]: "initial assessment",
  [ApiReportReportTypeChoices.Reassessment]: "reassessment",
};
const DEFAULT_REPORT_TYPE_LABEL = "report";
const UNKNOWN_CLIENT_INITIALS = "?";

// Python's str.split() whitespace (str.isspace), which differs from JS \s: it adds \x1c-\x1f and \x85, drops \ufeff.
const PYTHON_WHITESPACE = /[\t-\r\x1c-\x20\x85\xa0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+/;

/** First letter of up to the first two words of the name, uppercased, like frontera's extract_initials. */
const clientInitials = (firstName?: string | null, lastName?: string | null) => {
  const words = [firstName, lastName].filter(Boolean).join(" ").split(PYTHON_WHITESPACE).filter(Boolean);
  // Indexed and sliced by code point, as Python does, so a character outside the BMP is never split in half.
  const initials = words.map((word) => Array.from(word)[0].toUpperCase()).join("");
  return Array.from(initials).slice(0, 2).join("") || UNKNOWN_CLIENT_INITIALS;
};

/** e.g. "initial assessment for YM". */
export const reviewReportName = (report: Pick<ReportNode, "reportType" | "reportClientDetails">) => {
  const type = REPORT_TYPE_LABELS[report.reportType] ?? DEFAULT_REPORT_TYPE_LABEL;
  const details = report.reportClientDetails;
  return `${type} for ${clientInitials(details?.clientFirstName, details?.clientLastName)}`;
};
